import React from 'react';
import Navbar from '../Navbar/Navbar';

import SnackbarProvider from '../../../application/SnackbarProvider/SnackbarProvider';
import { ErrorHandler } from '../../ErrorHandler/ErrorHandler';
import { useSearchParams } from 'react-router-dom';
interface DefaultLayoutProps {
  children: React.ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  let showNavbar = true;
  const [searchUrlParams] = useSearchParams();
  const embeded = searchUrlParams.get('embeded');
  if (embeded && embeded === 'true') {
    showNavbar = false;
  }
  return (
    <div>
      <ErrorHandler>
        <div>
          { showNavbar && <Navbar /> }
          <main>
            {children}
            <SnackbarProvider />
          </main>
        </div>
      </ErrorHandler>
    </div>
  );
};

export default DefaultLayout;
